// antd 5 theme aligned with src/styles/_tokens.scss. Keep values in sync with that file.
// Usage (once, at the app root):
//   import { ConfigProvider } from 'antd';
//   import antdTheme from './styles/antdTheme';
//   <ConfigProvider theme={antdTheme}>...</ConfigProvider>
const antdTheme = {
  token: {
    colorPrimary: '#00adff',
    colorInfo: '#00adff',
    colorSuccess: '#22c55e',
    colorWarning: '#f59e0b',
    colorError: '#ef4444',
    colorLink: '#0077b3',
    colorLinkHover: '#0090d4',

    colorText: '#1e293b',
    colorTextSecondary: '#64748b',
    colorTextTertiary: '#94a3b8',
    colorBorder: '#e2e8f0',
    colorBorderSecondary: '#eef2f6',
    colorBgLayout: '#f8fbff',
    colorBgContainer: '#ffffff',

    fontFamily: "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
    fontSize: 14,

    borderRadius: 8,
    borderRadiusSM: 6,
    borderRadiusLG: 12,

    controlHeight: 40,
    controlHeightSM: 32,
    controlHeightLG: 48,

    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.03)',
    boxShadowSecondary: '0 8px 24px rgba(0, 0, 0, 0.08)',

    motionEaseInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  },
  components: {
    Button: {
      fontWeight: 600,
    },
    Card: {
      borderRadiusLG: 20,
    },
    Modal: {
      borderRadiusLG: 20,
    },
    Table: {
      colorFillAlter: '#f8fafc',
    },
  },
};

export default antdTheme;
